import { Helmet } from 'react-helmet-async';
import { useTranslation } from 'react-i18next';
import { BRAND_NAME, BRAND_SITE_TITLE } from '../../lib/brand';

/**
 * SEO Component for dynamic meta tags
 * @param {Object} props
 * @param {string} props.title - Page title
 * @param {string} props.description - Meta description
 * @param {string} props.keywords - Meta keywords (optional)
 * @param {string} props.image - Open Graph image URL (optional)
 * @param {string} props.url - Canonical URL (optional)
 */
const SEO = ({ title, description, keywords, image, url }) => {
  const { t } = useTranslation();

  const siteTitle = BRAND_SITE_TITLE;
  const siteDescription = description || `${BRAND_NAME} — Her anınıza uygun kaliteli giyim. Türkiye'nin en sevilen hazır giyim markası.`;
  const siteUrl = url || window.location.href;
  const siteImage = image || '/og-image.jpg'; // Default OG image

  const fullTitle = title ? `${title} | ${siteTitle}` : siteTitle;

  return (
    <Helmet>
      {/* Basic Meta Tags */}
      <title>{fullTitle}</title>
      <meta name="description" content={siteDescription} />
      {keywords && <meta name="keywords" content={keywords} />}
      <meta name="viewport" content="width=device-width, initial-scale=1" />
      <meta charSet="utf-8" />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:url" content={siteUrl} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={siteDescription} />
      <meta property="og:image" content={siteImage} />
      <meta property="og:locale" content="tr_TR" />
      <meta property="og:site_name" content={BRAND_NAME} />

      {/* Twitter */}
      <meta property="twitter:card" content="summary_large_image" />
      <meta property="twitter:url" content={siteUrl} />
      <meta property="twitter:title" content={fullTitle} />
      <meta property="twitter:description" content={siteDescription} />
      <meta property="twitter:image" content={siteImage} />

      {/* Canonical URL */}
      <link rel="canonical" href={siteUrl} />
    </Helmet>
  );
};

export default SEO;
